import React, { Fragment, useState } from "react";
import SideBar from "./SideBar";
import NavHader from "./NavHader";
import Header from "./Header";
import ChatBox from "../ChatBox";
import { SidebarProvider, useSidebar } from "./SidebarContext";

// Mobile Overlay Component
const MobileOverlay = () => {
  const { isOpen, closeSidebar } = useSidebar();
  const [isMobile, setIsMobile] = useState(false);

  React.useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    
    checkMobile();
    window.addEventListener('resize', checkMobile);
    
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  if (!isMobile || !isOpen) return null;

  return (
    <div 
      className="sidebar-overlay active"
      onClick={closeSidebar}
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        zIndex: 105,
        opacity: 1,
        visibility: 'visible',
        transition: 'all 0.3s ease-in-out'
      }}
    />
  );
};

const JobieNav = ({ title, onClick: ClickToAddEvent, onClick2, onClick3 }) => {
  const [toggle, setToggle] = useState("");
  const onClick = (name) => setToggle(toggle === name ? "" : name);
  return (
    <SidebarProvider>
      <Fragment>
        <NavHader />
        <ChatBox onClick={() => onClick("chatbox")} toggle={toggle} />
        <Header
          onNote={() => onClick("chatbox")}
          onNotification={() => onClick("notification")}
          onProfile={() => onClick("profile")}
          toggle={toggle}
          title={title}
          onBox={() => onClick("box")}
          onClick={() => ClickToAddEvent()}
        />
        <MobileOverlay />
        <SideBar />
      </Fragment>
    </SidebarProvider>
  );
};

export default JobieNav;
